<template>
    <div class="connection-card-pp" :class="{ 'is-opportunity': isOpportunity }">
        <div class="card">
            <div class="resume">
                <StarsPPFix :starsFullNumber="getStarsNumber" v-if="showStarsNumber" />

                <div v-if="showProgress">
                    <vue-circle
                        :progress="getProgress"
                        :size="65"
                        :reverse="false"
                        line-cap="round"
                        :fill="{ color: '#22B8CF' }"
                        empty-fill="#99E9F2"
                        :animation-start-value="0.0"
                        :start-angle="30"
                        insert-mode="append"
                        :thickness="6"
                        :show-percent="true"
                    ></vue-circle>

                    <div class="text">compatibilidade</div>
                </div>

                <div class="connected-status" v-if="getIsConnection">
                    <div class="status">Conectado</div>
                </div>
            </div>

            <img class="logo" :src="getUrlLogo" alt="connection-logo-card" v-if="showImageId" />

            <h5 class="name ellipsis" :class="{ 'small-name': smallName }" :title="getName">{{ getName }}</h5>
            <div class="city ellipsis" :title="getCity">{{ getCity }}</div>
            <div class="ods">
                <div>ODS:</div>
                <div class="all-ods">
                    <div class="ods-item" v-for="(item, index) in getOds" :key="index">
                        <img :src="require(`@/assets/img-section2-${item}.svg`)" alt="" />
                    </div>
                </div>
            </div>
            <div class="area ellipsis" :title="getArea">Área de atuação: {{ getArea }}</div>

            <slot name="footer-buttons"></slot>
        </div>
    </div>
</template>

<script>
import StarsPPFix from '@/ui/stars-pp/StarsPPFix'
import VueCircle from 'vue2-circle-progress'

export default {
    name: 'ConnectionCardPP',
    components: { StarsPPFix, VueCircle },
    props: {
        name: {
            type: String,
            default: ''
        },
        urlLogo: {
            type: String,
            default: null
        },
        city: {
            type: String,
            default: ''
        },
        ods: {
            type: Array,
            default: () => []
        },
        area: {
            type: Array,
            default: () => []
        },
        progress: {
            type: Number,
            default: 0
        },
        showProgress: {
            type: Boolean,
            default: false
        },
        smallName: {
            type: Boolean,
            default: false
        },
        starsNumber: {
            type: Number,
            default: 0
        },
        showStarsNumber: {
            type: Boolean,
            default: false
        },
        isConnection: {
            type: Boolean,
            default: false
        },
        showImageId: {
            type: Boolean,
            default: false
        },
        isOpportunity: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            cardName: null,
            cardStarsNumber: 0,
            areaOptions: [
                { text: 'Ações Afirmativas: raça, gênero e protagonismo jovem', item: 1, value: 1 },
                { text: 'Esporte & Saúde', item: 2, value: 2 },
                { text: 'Advocacy & Incidência Política', item: 3, value: 3 },
                { text: 'Habitação', item: 4, value: 4 },
                { text: 'Arte & Cultura', item: 5, value: 5 },
                { text: 'Inclusão Digital', item: 6, value: 6 },
                { text: 'Assistência Social', item: 7, value: 7 },
                {
                    text:
                        'Inclusão Produtiva (empreendedorismo, empregabilidade e capacitação para o mercado de trabalho, geração de trabalho e renda)',
                    item: 8,
                    value: 8
                },
                { text: 'Bem Viver & Qualidade de Vida', item: 9, value: 9 },
                { text: 'Comunicação & Marketing', item: 10, value: 10 },
                { text: 'Justiça Racial', item: 11, value: 11 },
                { text: 'Defesa de direitos da população LGBTQIAP+', item: 12, value: 12 },
                { text: 'Meio ambiente / Sustentabilidade', item: 13, value: 13 },
                { text: 'Defesa de direitos da população negra', item: 14, value: 14 },
                { text: 'Mobilidade Urbana', item: 15, value: 15 },
                { text: 'Defesa de direitos das mulheres', item: 16, value: 16 },
                { text: 'Paz & Justiça', item: 17, value: 17 },
                { text: 'Defesa de direitos dos povos indígenas', item: 18, value: 18 },
                { text: 'PCD (Pessoas com Deficiência)', item: 19, value: 19 },
                { text: 'Desenvolvimento Comunitário', item: 20, value: 20 },
                { text: 'Pesquisa / Produção de Conhecimento', item: 21, value: 21 },
                { text: 'Direito dos Animais', item: 22, value: 22 },
                { text: 'Refugiados', item: 23, value: 23 },
                { text: 'Direitos humanos, justiça social e cidadania', item: 24, value: 24 },
                { text: 'Saúde', item: 25, value: 25 },
                { text: 'Economia criativa e solidária', item: 26, value: 26 },
                { text: 'Tecnologias Sociais', item: 27, value: 27 },
                { text: 'Educação', item: 28, value: 28 },
                { text: 'Outro (especifique)', item: 29, value: 29 }
            ]
        }
    },
    computed: {
        getName() {
            return this.name
        },
        getUrlLogo() {
            return this.urlLogo ? this.$PPP_URL_FILE + this.urlLogo : require(`@/assets/connection-logo-card.svg`)
        },
        getProgress() {
            return this.progress
        },
        getStarsNumber() {
            return this.starsNumber
        },
        getIsConnection() {
            return this.isConnection
        },
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        },
        getOds() {
            return this.ods
        },
        getCity() {
            return this.city
        },
        getArea() {
            if (this.area.length) {
                return this.areaOptions
                    .filter(item => this.area.includes(item.value))
                    .map(item => item.text)
                    .join('; ')
            } else {
                return ''
            }
        }
    }
}
</script>

<style scope src="./ConnectionCardPP-light-theme.css"></style>
<style scope src="./ConnectionCardPP-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/ui/connection-card-pp/ConnectionCardPP.vue